import type { CSSProperties } from "react";
import { cx } from "../utils/format";

export interface AccentOption { id: string; label: string; hex: string; }
/** A row of colour swatches to pick the accent from, and one more for any colour: the browser's own picker. The colours are data,
 *  passed in as inline variables like avatar tints. `value` is a hex; the matching preset is marked, or Custom when none matches. */
export function AccentPicker({ value, presets, onChange, label = "Accent colour", disabled }: { value: string; presets: AccentOption[]; onChange: (hex: string) => void; label?: string; /** the signature's colours (2026-10-28): read-only with their editor */ disabled?: boolean }) {
  const custom = !presets.some((p) => p.hex === value);
  return (
    <div className="ob-accents" role="radiogroup" aria-label={label}>
      <div className="ob-accents__row">
        {presets.map((p) => (
          <button key={p.id} type="button" role="radio" aria-checked={p.hex === value} aria-label={p.label} title={p.label} className={cx("ob-accents__swatch", p.hex === value && "ob-accents__swatch--on")} style={{ "--swatch": p.hex } as CSSProperties} disabled={disabled} onClick={() => onChange(p.hex)} />
        ))}
      </div>
      {/* the second row, as wide as the swatches: the colour as it is now, and any colour from the browser's picker */}
      <label className={cx("ob-accents__custom", custom && "ob-accents__custom--on")} title="Any colour" style={{ "--swatch": value } as CSSProperties}>
        <span className="ob-accents__current" aria-hidden="true" />
        <input type="color" className="ob-accents__input" value={value} aria-label="Any colour" disabled={disabled} onChange={(e) => onChange(e.target.value)} />
        <span className="ob-accents__custom-text">{value}</span>
      </label>
    </div>
  );
}
